import VueformRadioElement from './components/design-system/form/VueformRadioElement.vue';
import VueformPasswordElement from './components/design-system/form/VueformPasswordElement.vue';
import VueformCalendarElement from './components/design-system/form/VueformCalendarElement.vue';

export const elements = [
  VueformPasswordElement,
  VueformCalendarElement,
  VueformRadioElement,
];
